import { Array } from '@common/Array/Array'

import type { TBrowser } from '../definitions'
import { SAFARI_BROWSERS } from '../definitions'

/**
 * Safarit használ a user.
 * @param browser - Browser típusa.
 */
export default function isSafari (browser: TBrowser): boolean {
  return Array.includes(SAFARI_BROWSERS, browser)
}
